export const annotations: Record<
    string,
    { title: string; subtitle: string; dx: number; dy: number }
  > = {
    // 'Divonne-les-Bains': {
    //   title: 'Appartements les plus chers',
    //   subtitle:
    //     'Divonne est la commune où les appartements sont les plus chers.',
    //   dx: -50,
    //   dy: -20,
    // },
    // 'Ferney-Voltaire': {
    //   title: 'Maisons les plus chères',
    //   subtitle: 'C’est à Ferney',
    //   dx: 30,
    //   dy: 80,
    // },
    // Megève: {
    //   title: 'Maisons les plus chères',
    //   subtitle: 'Megève est la commune où les maisons sont les plus chers.',
    //   dx: 80,
    //   dy: 40,
    // },
    // 'La Clusaz': {
    //   title: 'Appartements les plus chers',
    //   subtitle: 'C’est à La Clusaz',
    //   dx: -50,
    //   dy: 120,
    // },
  }